import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "create-hydrated-mock"
    }}>{`Create hydrated mock`}</h1>
    <p>{`Do you need to mock `}<strong parentName="p">{`optional`}</strong>{` properties or union types that may be undefined? `}<br />{`
Say hello to `}<strong parentName="p">{`createHydratedMock`}</strong>{`, it will help you create mocks that will treat optional interfaces as they were not optional`}</p>
    <p>{`We currently support optional token (?) and union types that contains undefined.`}</p>
    <h2 {...{
      "id": "optional-interfaces"
    }}>{`Optional interfaces`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createHydratedMock } from 'ts-auto-mock';

interface Person {
  id?: string;
  details?: {
      phone?: number
  }
}
const mock = createHydratedMock<Person>();
mock.id // ""
mock.details // { phone: 0 }
`}</code></pre>
    <h2 {...{
      "id": "union-types"
    }}>{`Union types`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createHydratedMock } from 'ts-auto-mock';

interface Person {
  getName(): string | undefined;
  getSurname(): undefined | string;
}
const mock = createHydratedMock<Person>();
mock.getName() // ''
mock.getSurname() // ''
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "note-from-the-team"
    }}>{`Note from the team`}</h2>
    <p>{`We completely understand the need of this functionality, but we would like the usage to be much simpler.  `}<br />{`
We would like to use the existing createMock in combination of typescript Required interface`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMock } from 'ts-auto-mock';

interface Person {
  id?: string;
}
type Required<T> = { // from typescript lib
    [P in keyof T]-?: T[P];
};
const mock = createMock<Required<Person>>();
mock.id // ""
`}</code></pre>
    <p>{`Unfortunately this doesn't work because we don't fully support map types.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      